var MainModule = (function () {
    function MainModule() {
    }
    return MainModule;
}());
export { MainModule };



// WEBPACK FOOTER //
// /opt/app/src/app/main/main.module.ts.pre-build-optimizer.js